import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Komfort",
    text: "Czyste, zadbane samochody i spokojna podróż. Wsiadasz, wygodnie siadasz — reszta należy do nas.",
    testId: "why-komfort",
  },
  {
    number: "02",
    title: "Bezpieczeństwo",
    text: "Doświadczony kierowca, sprawny pojazd i rozsądna jazda. Twoje bezpieczeństwo jest u nas na pierwszym miejscu.",
    testId: "why-bezpieczenstwo",
  },
  {
    number: "03",
    title: "Punktualność",
    text: "Odbieramy Cię o umówionej godzinie — zawsze. Samolot, wesele czy wizyta u lekarza nie poczekają, my też nie.",
    testId: "why-punktualnosc",
  },
  {
    number: "04",
    title: "Indywidualne podejście",
    text: "Każdy przejazd ustalamy pod Ciebie: trasę, godziny, przystanki i liczbę pasażerów. Jesteśmy do Twojej dyspozycji.",
    testId: "why-indywidualne",
  },
];

export const WhyUs = () => (
  <section data-testid="why-us-section" className="border-y border-white/10 bg-[#0D0D0D]">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="mb-4 font-display text-xs font-semibold tracking-[0.3em] text-[#E2C792]">
          DLACZEGO WARTO
        </p>
        <h2 className="max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
          Cztery powody, <span className="text-[#E2C792]">jedna decyzja</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 md:mt-20">
        {CHAPTERS.map((chapter, i) => (
          <motion.article
            key={chapter.number}
            data-testid={chapter.testId}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group bg-[#0D0D0D] p-8 transition-colors duration-300 hover:bg-[#141414] md:p-12"
          >
            <span className="font-display text-6xl font-extrabold tracking-tight text-white/15 transition-colors duration-300 group-hover:text-[#E2C792]/40 md:text-7xl">
              {chapter.number}
            </span>
            <h3 className="mt-5 font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
              {chapter.title}
            </h3>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60 md:text-base">
              {chapter.text}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
